module.exports = __webpack_public_path__ + "static/media/ncl_vessels-mobile.a543a351.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cases/ncl_vessels-mobile.png
// module id = 384
// module chunks = 0